module.exports = __webpack_public_path__ + "static/media/understand-yourself.6265c766.svg";